// src/lib/BaseEquationPlugin.ts
import { bindFirst as bindFirst2, createSlatePlugin as createSlatePlugin2 } from "@udecode/plate";

// src/lib/transforms/insertEquation.ts
var insertEquation = (editor, options) => {
  editor.tf.insertNodes(
    {
      children: [{ text: "" }],
      texExpression: "",
      type: editor.getType(BaseEquationPlugin)
    },
    options
  );
};

// src/lib/BaseInlineEquationPlugin.ts
import { bindFirst, createSlatePlugin } from "@udecode/plate";
var BaseInlineEquationPlugin = createSlatePlugin({
  key: "inline_equation",
  node: { isElement: true, isInline: true, isVoid: true }
}).extendEditorTransforms(({ editor }) => ({
  insert: {
    inlineEquation: bindFirst(insertInlineEquation, editor)
  }
}));

// src/lib/transforms/insertInlineEquation.ts
var insertInlineEquation = (editor, texExpression, options) => {
  editor.tf.insertNodes(
    {
      children: [{ text: "" }],
      texExpression: texExpression ?? editor.api.string(editor.selection),
      type: editor.getType(BaseInlineEquationPlugin)
    },
    options
  );
};

// src/lib/BaseEquationPlugin.ts
import "katex/dist/katex.min.css";
var BaseEquationPlugin = createSlatePlugin2({
  key: "equation",
  node: { isElement: true, isVoid: true }
}).extendEditorTransforms(({ editor }) => ({
  insert: {
    equation: bindFirst2(insertEquation, editor)
  }
}));

// src/lib/utils/getEquationHtml.ts
import katex from "katex";
var getEquationHtml = ({
  element,
  options
}) => katex.renderToString(element.texExpression, options);
export {
  BaseEquationPlugin,
  BaseInlineEquationPlugin,
  getEquationHtml,
  insertEquation,
  insertInlineEquation
};
//# sourceMappingURL=index.mjs.map